"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const common_buoy_button_1 = require("@buoyhealth/common.buoy-button");
/**
 * Action buttons for Drawer and Modal
 */
const ActionButtons = ({ actions }) => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: actions.map(({ isCta, isPrimary, isTextBtn, label, hidden, ...remaining }) => {
            if (hidden) {
                return;
            }
            if (isCta) {
                return ((0, jsx_runtime_1.jsx)(common_buoy_button_1.CTAButton, { ...remaining, children: label }, label));
            }
            if (isPrimary) {
                return ((0, jsx_runtime_1.jsx)(common_buoy_button_1.PrimaryButton, { ...remaining, children: label }, label));
            }
            if (isTextBtn) {
                return ((0, jsx_runtime_1.jsx)(common_buoy_button_1.TextButton, { ...remaining, children: label }, label));
            }
            return ((0, jsx_runtime_1.jsx)(common_buoy_button_1.SecondaryButton, { ...remaining, children: label }, label));
        }) }));
};
exports.default = ActionButtons;
//# sourceMappingURL=ActionButtons.js.map